// extracted by mini-css-extract-plugin
export var licenses__col = "licenses-module--licenses__col--b4e96";
export var licenses__img = "licenses-module--licenses__img--131e6";
export var licenses__imgBlock = "licenses-module--licenses__img-block--eed15";
export var licenses__imgFullScreen = "licenses-module--licenses__img--full-screen--dc726";
export var licenses__name = "licenses-module--licenses__name--86ecb";
export var licenses__pagination = "licenses-module--licenses__pagination--a824f";
export var licenses__zoomIn = "licenses-module--licenses__zoom-in--12c60";